/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiPublicSiteDtoLoginWithPasswordCodeDto
 */
export interface WebApiPublicSiteDtoLoginWithPasswordCodeDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoLoginWithPasswordCodeDto
     */
    companyUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoLoginWithPasswordCodeDto
     */
    passwordCode?: string | null;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoLoginWithPasswordCodeDto interface.
 */
export function instanceOfWebApiPublicSiteDtoLoginWithPasswordCodeDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoLoginWithPasswordCodeDtoFromJSON(json: any): WebApiPublicSiteDtoLoginWithPasswordCodeDto {
    return WebApiPublicSiteDtoLoginWithPasswordCodeDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoLoginWithPasswordCodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoLoginWithPasswordCodeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyUrl': !exists(json, 'companyUrl') ? undefined : json['companyUrl'],
        'passwordCode': !exists(json, 'passwordCode') ? undefined : json['passwordCode'],
    };
}

export function WebApiPublicSiteDtoLoginWithPasswordCodeDtoToJSON(value?: WebApiPublicSiteDtoLoginWithPasswordCodeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyUrl': value.companyUrl,
        'passwordCode': value.passwordCode,
    };
}

